<nav class="navbar" [class.scrolled]="isScrolled">
  <div class="navbar-container">
    <a class="navbar-brand" routerLink="/">
      <span class="logo">
        <span class="text-white">HORIZON</span>
        <span class="text-accent">NET.</span>
        <img src="assets/Hnet-Finalsvg-01-01.svg" alt="HorizonNet Logo">
      </span>
    </a>

    <!-- Navigation Links -->
    <div class="nav-links" [class.open]="isMobileMenuOpen">
      <ng-container *ngFor="let item of navItems">
        <a 
          class="nav-link hover-effect" 
          [routerLink]="item.isExternal ? null : item.path"
          [routerLinkActiveOptions]="{exact: item.path === '/'}"
          routerLinkActive="active"
          (click)="navigateToLink(item)"
        >
          {{item.label}}
        </a>
      </ng-container>
      
      <!-- Login Button im Mobile Menu -->
      <button *ngIf="showLoginInMenu" class="cta-button hover-effect" routerLink="/login" (click)="isMobileMenuOpen = false">
        <span>Login</span>
      </button>
    </div>

    <div class="nav-right">
      <!-- Cart Button -->
      <button *ngIf="isShopPage" class="cart-button hover-effect" (click)="openCart()">
        <mat-icon>shopping_cart</mat-icon>
        <span class="cart-count" *ngIf="cartService.getCartCount()">
          {{ cartService.getCartCount() }}
        </span>
      </button>

      <button class="cta-button hover-effect" routerLink="/login" *ngIf="!showLoginInMenu">
        <span>Login</span>
      </button>
      
      <!-- Burger Menu Button -->
      <button class="mobile-menu-button" (click)="toggleMobileMenu()" [class.active]="isMobileMenuOpen">
        <span class="burger-line"></span>
        <span class="burger-line"></span>
        <span class="burger-line"></span>
      </button>
    </div>
  </div>
  <app-cart-sidebar></app-cart-sidebar>
</nav> 